import { ReportFilter } from 'app/filters/types';
import { OfflineRecordDataAccssor } from './offline-record-data-accessor';

export class OfflineCardDataAccessor extends OfflineRecordDataAccssor {
  // no difference now as filter model manages grouping
  // can consider removing
}
